import {
	GET_EMPLOYERS_REQUEST,
	GET_EMPLOYERS_SUCCESS,
	GET_EMPLOYERS_ERROR,
	GET_EMPLOYER_REQUEST,
	GET_EMPLOYER_SUCCESS,
	GET_EMPLOYER_ERROR,
	CREATE_EMPLOYER_REQUEST,
	CREATE_EMPLOYER_SUCCESS,
	CREATE_EMPLOYER_ERROR,
	EDIT_EMPLOYER_REQUEST,
	EDIT_EMPLOYER_SUCCESS,
	EDIT_EMPLOYER_ERROR,
	DELETE_EMPLOYER_REQUEST,
	DELETE_EMPLOYER_SUCCESS,
	DELETE_EMPLOYER_ERROR
} from "@/actions"

import { employerService } from "@/services"

import { addNewFilter, isEmpty, decodeLaravelValidationErrors } from "@/utilities"

const state = {
	employers: [],
	employer: {},
	loading: false,
	loadedOnce: false
}

const getters = {
	employersLoadedOnce: state => state.loadedOnce,
	employers: state => state.employers,
	employerSelectOptions: state => state.employers.map(e => ({ value: e.uuid, label: e.full_name })),
	employerFilter: state => uuid => state.employers.find(emp => emp.uuid == uuid)
}

const actions = {
	async getEmployers({ commit }) {
		commit("GET_EMPLOYERS_REQUEST")
		const response = await employerService.getEmployers();
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_EMPLOYERS_SUCCESS", data)
				break
			default:
				commit("GET_EMPLOYERS_ERROR", data)
		}
		return response
	},
	async getEmployer({ commit }, params) {
		commit("GET_EMPLOYER_REQUEST")
		const response = await employerService.getEmployer(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_EMPLOYER_SUCCESS", data)
				break
			default:
				commit("GET_EMPLOYER_ERROR", data)
				break
		}
		return response
	},
	async createEmployer({ commit, dispatch }, params) {
		commit("CREATE_EMPLOYER_REQUEST")
		const response = await employerService.createEmployer(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("CREATE_EMPLOYER_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Employer created.", { root: true })
				}

				if (data?.error) {
					commit("CREATE_EMPLOYER_ERROR");
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data?.errors) : "Opps. Something went wrong.", { root: true })
				}
				break
			default:
				commit("CREATE_EMPLOYER_ERROR")
		}
		return response
	},
	async editEmployer({ commit, dispatch }, params) {
		commit("EDIT_EMPLOYER_REQUEST")
		const response = await employerService.editEmployer(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("EDIT_EMPLOYER_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Employer updated.", { root: true });
				}

				if (data?.error) {
					commit("EDIT_EMPLOYER_ERROR");
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data?.errors) : "Opps. Something went wrong.", { root: true })
				}
				break
			default:
				commit("EDIT_EMPLOYER_ERROR")
		}
		return response
	},
	async deleteEmployer({ commit, dispatch }, uuid) {
		commit("DELETE_EMPLOYER_REQUEST")
		const response = await employerService.deleteEmployer(uuid)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					const { employer } = data
					commit("DELETE_EMPLOYER_SUCCESS", { ...employer, uuid });
					dispatch("alert/createAlertSuccess", "Employer deleted.", { root: true });
				}

				if (data?.error) {
					commit("DELETE_EMPLOYER_ERROR");
					dispatch("alert/createAlertErrors", data?.errors ? decodeLaravelValidationErrors(data?.errors) : "Opps. Something went wrong.", { root: true })
				}

				break
			default:
				commit("DELETE_EMPLOYER_ERROR")
		}
		return response
	},
	async convertToEmployer({ commit, dispatch }, params) {
		commit("CONVERT_TO_EMPLOYER_REQUEST");

		const response = await employerService.convertToEmployer(params)

		commit("CONVERT_TO_EMPLOYER_SUCCESS");

		return response;
	}
}

const mutations = {
	[GET_EMPLOYERS_REQUEST]: state => {
		state.loading = true
	},
	[GET_EMPLOYERS_SUCCESS]: (state, data) => {
		let employers = [...data.employers]
		state.employers = employers
		state.loading = false
		state.loadedOnce = true
	},
	[GET_EMPLOYERS_ERROR]: state => {
		state.loading = false
		state.error = true
		state.loadedOnce = true
	},
	[GET_EMPLOYER_REQUEST]: state => {
		state.loading = true
	},
	[GET_EMPLOYER_SUCCESS]: (state, data) => {
		const { employer } = data
		state.employers = addNewFilter(state.employers, [employer])
		state.loading = false
	},
	[GET_EMPLOYER_ERROR]: state => {
		state.loading = false
	},

	[CREATE_EMPLOYER_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_EMPLOYER_SUCCESS]: (state, data) => {
		const { employer } = data
		state.employers = addNewFilter(state.employers, [employer])
		state.loading = false
	},
	[CREATE_EMPLOYER_ERROR]: state => {
		state.loading = false
	},

	[EDIT_EMPLOYER_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_EMPLOYER_SUCCESS]: (state, data) => {
		const { employer } = data
		state.employers = addNewFilter(state.employers, [employer])
		state.loading = false;
	},
	[EDIT_EMPLOYER_ERROR]: state => {
		state.loading = false
	},

	[DELETE_EMPLOYER_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_EMPLOYER_SUCCESS]: (state, employer) => {
		const { uuid, deleted_at } = employer;
		if (!isEmpty(deleted_at)) {
			state.employers = addNewFilter(state.employers, [employer])
		} else {
			state.employers = state.employers.filter(e => e.uuid !== uuid)
		}

		state.loading = false
	},
	[DELETE_EMPLOYER_ERROR]: (state) => {
		state.loading = false
	},
	CONVERT_TO_EMPLOYER_REQUEST: (state) => {
		state.loading = true;
	},
	CONVERT_TO_EMPLOYER_SUCCESS: (state) => {
		state.loading = false;
	},
}

export const employer = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}